import { render, staticRenderFns } from "./Sensitivity.vue?vue&type=template&id=0c0a732d&"
import script from "./Sensitivity.vue?vue&type=script&lang=js&"
export * from "./Sensitivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports